import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

class MMPickupOrderStore extends EventEmitter {
    PageLoadData = "";
    SubmitResponse = "";
    ChangeAssigntoResponse = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handlePickingStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.GetPickingOrders: {
                this.PageLoadData = action.action.response;
                this.emit('PickingPageLoad');
                break;
            }

            case SDIConstants.methodNames.UploadPickupOrder: {
                this.SubmitResponse = action.action.response;
                this.emit('SubmitResponse');
                break;
            }
            //[10/28/22], PC_WW-529_11, Dhevanesam R
            case SDIConstants.methodNames.ChangeAssignto: {
                this.ChangeAssigntoResponse = action.action.response;
                this.emit('ChangeAssigntoResponse');
                break;
            }
            case "geo": {
                this.SubmitResponse = action.action.response;
                this.emit('geo');
                break;
            }
            case "NOTIFY_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
        }
    }
}
const objPickingStore = new MMPickupOrderStore;
// Dispatcher code
Dispatcher.register(objPickingStore.handlePickingStore.bind(objPickingStore));
export default objPickingStore;